import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useDeleteCar = (onSuccess: () => void) => {
  const mutation = useMutation({
    mutationFn: (id: string) => API.deleteCar(id),
    onSuccess: () => {
      onSuccess();
    },
  });

  return {
    deleteCar: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
